interface FileUrls {
    url: string;
    url128: string;
    url512: string;
}

/// URL of a thumbnail which fits inside 128 or 512 pixels. Falls back to
/// the original while the thumbnails haven't been generated yet.
export function thumbnailUrl(file: FileUrls | null | undefined, size: 'url128' | 'url512'): string {
    return file?.[size] || file?.url || '';
}
